export default class ExtensionCategoryQuestionCreateModel {
  public extensionCategoryId: string = ''
  public question: string = ''
  public isBarrier: boolean = false
  public isChange: boolean = false
  public isHumanFactor: boolean = false
  public isEvent: boolean = false
  public isData: boolean = false
  public order: number = 0

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
